// extracted by mini-css-extract-plugin
module.exports = {"module":"Dashboard_module__3cXKJ","overview":"Dashboard_overview__kCkDL","distributionView":"Dashboard_distributionView__23v-s","noData":"Dashboard_noData__6frHL"};